import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { PageProjects } from "@components/modules/clients/projects/PageProjects";
import { NavigationClient } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Client projects`}
    navigation={<NavigationClient id={id} variant="panel" />}
  >
    <PageProjects />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/clients/projects")({
  component: RouteComponent,
});
